import { PartnerOnboardingApplication, PartnerOnboardingEntityRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchOnboardingApplication() {
  const [fetchingOnboardingApplication, setFetchingOnboardingApplication] = useState(false);
  const [onboardingApplication, setOnboardingApplication] = useState<PartnerOnboardingApplication>();

  async function fetchOnboardingApplication(params: PartnerOnboardingEntityRequest) {
    try {
      setFetchingOnboardingApplication(true);
      const res = await api.fetchPartnerOnboardingApplication(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setOnboardingApplication(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingOnboardingApplication(false);
    }
  }

  return { fetchingOnboardingApplication, onboardingApplication, fetchOnboardingApplication };
}
